<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import Tile from '@/components/tile.vue';
import { ADDON_GROUP, planTypes, ZOOM_MEETING_EDU_PLUS_MIN_LICENSE } from '@/common/constants';
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommonMixin from './mixin';
import addonCustomSelect from '@/plans/mx/addonCustomSelect';
import { addDefaultPbxBasePlanToShoppingCartByQuery } from '@/flows/BUY_NOW';

export default {
  name: 'EduPlusAddOnCard',
  mixins: [base,planCommonMixin,addonCustomSelect],
  components: {
    Tile,
  },
  group() {
    return [ADDON_GROUP.WIN_BACK];
  },
  for() {
    return true;
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
    this.productPlans = this.currentProductPlans;
    //
    this.$root.$on('trigger-add-zoom-one', () => this.$emit('add'));
  },
  computed: {
    ...mapGetters(['getSelectedPlans','selectedPbxBasePlan']),
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    currentProductPlans() {
      return orderBy(filter(this.planMapFlat, (p) => p.type === this.planType && !p.isOneMonth), ['participants', 'amount'], 'asc');
    },
    lowestPlan() {
      return get(this.currentProductPlans, [0], {});
    },
    //mixins overwrite
    // eslint-disable-next-line no-unused-vars
    addCategoryCode() {
      const { categoryCode } = this.pastPlans.find((item) => planTypes[item.semanticType] === this.planType) || {};
      if (categoryCode && this.planInfoGroupByCategory[categoryCode.toLowerCase()]) {
        return categoryCode.toLowerCase();
      }
      return 'zoneduschcmppusca';
    },
  },
  methods: {
    ...mapMutations(['setPbxBasePlanCode','setPlanMapFlat']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt?.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: ZOOM_MEETING_EDU_PLUS_MIN_LICENSE,
        },
      });
      this.$emit('add', this.$options?.key);
      //const hasOtherZp = this.getSelectedPlans.some(item => item.type === planTypes.ZOOM_PHONE && item.billingCycle !== BILLING_CYCLE.PAY_AS_YOU_GO);
      //add phone usage plan
      addDefaultPbxBasePlanToShoppingCartByQuery(this.planMapFlat);
      this.setPlanMapFlat([...this.planMapFlat]);
      if (this.selectedPbxBasePlan) {
        this.setPbxBasePlanCode(this.selectedPbxBasePlan.plan_code);
        this.savePersist()
      }
      this.$tracking.addOnBuyInteraction(`${this.trackingBasePlanName} add-ons`, `add-ons - ${this.title?.toLowerCase()} - ${this.trackingAddAction}`);
      this.$nextTick(this.focusToConfig);
    },
    mx_desc() {
      return <div class="opc-addon__description first-capitalize">
        {this.description}
      </div>;
    },
  },
};
</script>
